import { QUERY_KEYS } from "@/libraries/constant";
import { getStoragesQueryOptions } from "@/queries";
import { onlineManager } from "@tanstack/react-query";
import type { RouteContext } from "@tanstack/react-router";

export const getGalleries = async (ctx: RouteContext) => {
	if (onlineManager.isOnline() && !ctx.isRestoring) {
		return ctx.queryClient.ensureInfiniteQueryData(getStoragesQueryOptions());
	}
	return ctx.queryClient.getQueryData([QUERY_KEYS.GET_STORAGES]);
};
